/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlUncontainFileAction = {
    Unquarantine: 'unquarantine'
} as const;
export type ControlUncontainFileAction = typeof ControlUncontainFileAction[keyof typeof ControlUncontainFileAction];


export function ControlUncontainFileActionFromJSON(json: any): ControlUncontainFileAction {
    return ControlUncontainFileActionFromJSONTyped(json, false);
}

export function ControlUncontainFileActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlUncontainFileAction {
    return json as ControlUncontainFileAction;
}

export function ControlUncontainFileActionToJSON(value?: ControlUncontainFileAction | null): any {
    return value as any;
}

